function popupClose(){
    document.getElementById('popupContainer').classList.add('hidden');
    var popupRandom = document.querySelectorAll('.text-with-button--popup__random')
    for (let index = 0; index < popupRandom.length; index++) {
        popupRandom[index].classList.add('hidden');
    }
}

function openPopup(){
   var popupContainer = document.getElementById('popupContainer');
   var popupRandom = parseInt(popupContainer.getAttribute('data-total'));
   let randomPopup = document.getElementById('popupRandom--' + Math.floor((Math.random() * popupRandom) + 1));
   popupContainer.classList.remove('hidden');
   randomPopup.classList.remove('hidden');
}